import { apiClient, type Paginated } from '@/core/api';

export type LessonKind = 'material' | 'guide' | 'video' | 'link';

/** Mirrors the existing LessonReadSerializer (apps/lms/serializers.py). */
export interface Lesson {
  id: number;
  course: number;
  title: string;
  content: string;
  kind: LessonKind;
  order: number;
  created: string;
  modified: string;
}

export interface LessonInput {
  course: number;
  title: string;
  content: string;
  kind: LessonKind;
  order: number;
}

const BASE = '/lms/lessons/';

export interface LessonListParams {
  page?: number;
  search?: string;
  course?: number;
  kind?: LessonKind;
  /** Comma-separated kinds for the cross-course Materials library. */
  kind__in?: string;
}

export async function listLessons(params: LessonListParams = {}): Promise<Paginated<Lesson>> {
  const { data } = await apiClient.get<Paginated<Lesson>>(BASE, { params });
  return data;
}

export async function createLesson(input: LessonInput): Promise<Lesson> {
  const { data } = await apiClient.post<Lesson>(BASE, input);
  return data;
}

export async function updateLesson(id: number, input: Partial<LessonInput>): Promise<Lesson> {
  const { data } = await apiClient.patch<Lesson>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteLesson(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}
